import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './FilterChips.css';

// Iconos predefinidos para filtros comunes
const FILTER_ICONS = {
  vegetariano: 'eco',
  vegetarian: 'eco',
  vegano: 'spa',
  vegan: 'spa',
  'sin gluten': 'grain',
  'gluten free': 'grain',
  'sin tacc': 'grain',
  picante: 'local_fire_department',
  spicy: 'local_fire_department',
  recomendado: 'thumb_up',
  recommended: 'thumb_up',
  nuevo: 'fiber_new',
  new: 'fiber_new',
  popular: 'trending_up',
  'sin lactosa': 'water_drop',
  'lactose free': 'water_drop',
};

// Obtener icono para un filtro
const getFilterIcon = (filter) => {
  const lowerFilter = filter.toLowerCase();
  for (const [key, icon] of Object.entries(FILTER_ICONS)) {
    if (lowerFilter.includes(key)) {
      return icon;
    }
  }
  return 'label';
};

function FilterChips({
  availableFilters = [],
  activeFilters = [],
  onFilterToggle,
  onClearAll,
}) {
  const { t } = useTranslation();
  const scrollRef = useRef(null);
  const [scrolledEnd, setScrolledEnd] = useState(false);

  const checkScrollEnd = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    setScrolledEnd(atEnd);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScrollEnd();
    el.addEventListener('scroll', checkScrollEnd, { passive: true });
    return () => el.removeEventListener('scroll', checkScrollEnd);
  }, [checkScrollEnd, availableFilters]);

  if (availableFilters.length === 0) {
    return null;
  }

  const hasActiveFilters = activeFilters.length > 0;

  return (
    <div className={`filter-chips ${scrolledEnd ? 'scrolled-end' : ''}`}>
      <div className="filter-chips__scroll" ref={scrollRef}>
        {/* Clear all button */}
        {hasActiveFilters && (
          <button
            className="filter-chip filter-chip--clear"
            onClick={onClearAll}
            aria-label={t('filters.clearAll')}
          >
            <span className="material-icons" aria-hidden="true">close</span>
            <span>{t('filters.clearAll')}</span>
          </button>
        )}

        {/* Filter chips */}
        {availableFilters.map((filter) => {
          const isActive = activeFilters.includes(filter.value);
          const icon = getFilterIcon(filter.label);

          return (
            <button
              key={filter.value}
              className={`filter-chip ${isActive ? 'active' : ''}`}
              onClick={() => onFilterToggle(filter.value)}
              aria-pressed={isActive}
            >
              <span className="material-icons filter-chip__icon" aria-hidden="true">{icon}</span>
              <span className="filter-chip__label">{filter.label}</span>
              {filter.count > 0 && (
                <span className="filter-chip__count">{filter.count}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FilterChips;
